import { type UiState } from './state';
import _ from 'lodash';

const openMiniCart = (state: UiState) => {
  return _.assign({}, state, {
    global: {
      isMiniCartOpen: true,
    },
  });
};

const closeMiniCart = (state: UiState) => {
  return _.assign({}, state, {
    global: {
      isMiniCartOpen: false,
    },
  });
};

export default { openMiniCart, closeMiniCart };
